import { Box, Stack } from '@mui/material'

import FeedTableIcon from 'assets/FeedTableIcon'
import { roundingNumber } from 'components/shared/processes'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary12 } from 'ui/typography/TypographyPrimary12'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { BaseWidget } from '../../../baseWidget'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

export const RemainingFeedProcent = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	const distributed = statistics?.distribution?.total ?? 0
	const leftover = statistics?.cleaning?.total ?? 0
	const leftoverPercent =
		distributed > 0 ? roundingNumber((leftover / distributed) * 100, 1) : 0

	if (!permissions?.license_food_table || error) return null

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<FeedTableIcon color={COLORS.main} width={16} height={16} />
				</Box>
			}
			path={'/feed/'}
			isLoading={loading}
		>
			<Stack direction='column' gap='4px'>
				{(leftover || leftover === 0) && (
					<Stack direction='row' alignItems='baseline' gap='4px'>
						<TypographyPrimary16Bold>{leftoverPercent}</TypographyPrimary16Bold>
						<TypographySecondary>%</TypographySecondary>
					</Stack>
				)}
				<TypographyPrimary>Суммарный остаток</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
